<template>
  <div class="tmPicker" @click.stop="showSelectPop">
    <el-input
      placeholder="请选择时间"
      suffix-icon="el-icon-time"
      v-model="myvalue"
      readonly
      @click.stop="showSelectPop"
    >
    </el-input>
    <div class="pop oclass" v-show="isShow">
      <div class="flex pickercontent">
        <el-radio-group class="day" v-model="day" v-show="!currDay">
          <el-radio :label="item" v-for="(item, index) in days" :key="index">{{
            item
          }}</el-radio>
        </el-radio-group>
        <el-radio-group class="day" v-model="hour">
          <el-radio :label="item" v-for="(item, index) in hours" :key="index">{{
            item
          }}</el-radio>
        </el-radio-group>
        <el-radio-group class="day" v-model="minute">
          <el-radio
            :label="item"
            v-for="(item, index) in minutes"
            :key="index"
            >{{ item }}</el-radio
          >
        </el-radio-group>
      </div>
      <div class="btns" style="text-align: right">
        <!-- <el-button type="text" @click.stop="cancel">取消</el-button> -->
        <el-button type="danger" @click.stop="confirm">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tmPicker",
  props: {
    value: {
      type: String,
    },
    currDay: {
      type: Boolean,
      default:false
    },
  },
  mounted() {
    document.body.addEventListener("click", (event) => {
      if (
        "oclass" !== event.target.className ||
        event.target.className.indexOf("oclass") < 0
      ) {
        setTimeout(() => {
          this.isShow = false;
        }, 10);
      }
    });
  },
  computed: {},
  watch: {
    value(newVal) {
      this.myvalue = newVal;
    },
    myvalue: function (val) {
      this.$emit("input", val);
    },
  },
  data() {
    return {
      myvalue: this.value,
      isShow: false,
      activeIndex: null,
      day: null,
      hour: null,
      minute: null,
      days: [
        "当天",
        "第二天",
        "第三天",
        "第四天",
        "第五天",
        "第六天",
        "第七天",
        "第八天",
        "第九天",
        "第十天",
      ],
      hours: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
      ],
      minutes: ["00", 10, 20, 30, 40, 50],
    };
  },
  methods: {
    showSelectPop() {
      this.isShow = !this.isShow;
    },
    cancel() {
      this.day = null;
      this.hour = null;
      this.minute = null;
      this.isShow = !this.isShow;
    },
    mapIndex(text) {
      let i = null;
      switch (text) {
        case "当天":
          i = 0;
          break;
        case "第二天":
          i = 1;
          break;
        case "第三天":
          i = 2;
          break;
        case "第四天":
          i = 3;
          break;
        case "第五天":
          i = 4;
          break;
        case "第六天":
          i = 5;
          break;
        case "第七天":
          i = 6;
          break;
        case "第八天":
          i = 7;
          break;
        case "第九天":
          i = 8;
          break;
        case "第十天":
          i = 9;
          break;
        default:
          i = 0;
          break;
      }
      return i;
    },
    confirm() {
      let day = this.day;
      let hour = this.hour;
      let minute = this.minute;
      let dayIndex = this.mapIndex(day);
      if ( !hour || !minute || (!this.currDay && !day)) return;
      let item = {
        dayIndex,
        day,
        hour,
        minute,
      };
      let dyna = ''
        if(!this.currDay){
            dyna = day + " "
        }
      this.myvalue = dyna + hour + ":" + minute;
      this.$emit("on-confirm", item);
      this.isShow = false;
    },
  },
};
</script>

<style scoped lang="less">
.tmPicker {
  display: inline-block;
  width: 225px;
  position: relative;
}
.pop {
  background-color: #fff;
  position: absolute;
  left: 0;
  top: 30px;
  box-shadow: 0 0 10px #aaa;
  margin-top: 0 !important;
  z-index: 99;
  padding: 20px !important;
}
.pickercontent {
  .el-radio-group {
    width: 100px;
    height: 250px;
    overflow-y: auto;
    border-right: 1px solid #eee;
    label {
      display: inline-block;
      height: 38px;
      line-height: 38px;
      width: 100%;
      margin-right: 0;
      &.is-checked {
        background: #eee;
      }
    }
    /deep/ .el-radio__inner {
      display: none;
    }
  }
}
</style>
